import React from "react";

const Facebook: React.FC = () => {
    return (
        <div className="d-block">
            <img src="/images/hr.png" className="my-5 mx-auto d-block" alt="Divider" />
            <iframe
                src="https://www.facebook.com/plugins/likebox.php?href=https%3A%2F%2Fwww.facebook.com%2Fpages%2FGenesee-Brew-House%2F211216188902766&amp;width=895px&amp;height=258&amp;colorscheme=light&amp;show_faces=true&amp;header=false&amp;stream=false&amp;show_border=false"
                style={{ border: "none", overflow: "hidden", width: "100%", height: "258px" }}
                allowTransparency={true}
                title="Genesee Brew House Facebook Page"
            ></iframe>
        </div>
    );
};

export default Facebook;
